import { AxiosPromise } from 'axios'
import { ApiServiceWithSettings, Audience, Authentication } from '../../common'
import {
  BonusLevelNameView,
  CalculateBonusPriceCommand,
  CalculateBonusPricesView,
  MinimalPriceLevelNameView,
  MinimalPricesView
} from '@one/types'

export class BackofficePricehelperApi extends ApiServiceWithSettings {
  getMinimalPricesLevels(): AxiosPromise<MinimalPriceLevelNameView> {
    return this.get('/minimal-prices/levels', {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  getMinimalPrices(skuIds: Array<string>): AxiosPromise<MinimalPricesView> {
    return this.post(
      '/minimal-prices',
      {
        skuIds
      },
      {
        authentication: Authentication.REQUIRED,
        aud: Audience.BACKOFFICE
      }
    )
  }

  getBonusLevelNames(): AxiosPromise<BonusLevelNameView> {
    return this.get('/bonuses/levels', {
      authentication: Authentication.REQUIRED,
      aud: Audience.BACKOFFICE
    })
  }

  calculateBonuses(
    bonusPrices: Record<string, CalculateBonusPriceCommand>
  ): AxiosPromise<CalculateBonusPricesView> {
    return this.post(
      '/bonuses/calculate',
      {
        bonusPrices
      },
      {
        authentication: Authentication.REQUIRED,
        aud: Audience.BACKOFFICE
      }
    )
  }
}
